/* eslint-disable import/prefer-default-export */
export const notifications = state => state.notifications;
